import { notification } from "antd";
import moment from "moment";
import { ANSWERS, RESPONSE_COLORS, ROLES } from "./constants";

export function setLocalStorage(name, data) {
  localStorage.setItem(name, JSON.stringify(data));
}

export function getLocalStorage(name) {
  const storedData = localStorage.getItem(name);
  if (storedData && storedData !== "undefined") {
    try {
      return JSON.parse(storedData);
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return null;
    }
  } else {
    return null;
  }
}

export function removeItem(name) {
  localStorage.removeItem(name);
}

export function formatLastActivityDate(time) {
  const formattedString = moment(time).format("MM/DD/YYYY,<br/> HH:mm:ss");
  return { __html: formattedString };
}

export function formatDateTime(time) {
  return moment(time).format("MM/DD/YYYY, HH:mm:ss");
}

// Format a plain calendar date (no time component) as MM/DD/YYYY.
// Returns "" for empty input and the original value if it can't be parsed,
// so it degrades gracefully. Timestamps/relative dates use their own helpers.
export function formatPlainDate(value) {
  if (!value) return "";
  const parsed = moment(
    value,
    ["YYYY-MM-DD", "MM/DD/YYYY", moment.ISO_8601],
    true
  );
  const m = parsed.isValid() ? parsed : moment(value);
  return m.isValid() ? m.format("MM/DD/YYYY") : value;
}

export const isPreAssessmentComplete = () => {
  return (
    getLocalStorage("USER_DETAILS") &&
    getLocalStorage("USER_DETAILS")?.pre_assessment_status === "Completed"
  );
};

export function getValidLandingScreen(userData) {
  const userDetails = userData || getLocalStorage("USER_DETAILS");
  return getRedirectPath(userDetails);
}

export function getRedirectPath(userDetails) {
  if (!userDetails) {
    localStorage.clear();
    return "/sign-in"; // Not authenticated
  }
  if (checkIsSuperAdmin()) {
    return "/super-admin";
  } else if (checkIsStateAdmin()) {
    return "/state-admin-dashboard";
  } else if (checkIsAdmin()) {
    if (isPreAssessmentComplete()) return "/admin-dashboard";
    else return "/pre-assessments";
  } else if (checkIsEmployee()) {
    return "/dashboard";
  }
  return "/unauthorized";
}

export const checkIsSuperAdminSubdomain = () =>
  window.location.href.includes(process.env.ADMIN_SUB_DOMAIN);

export const getUserRole = () => getLocalStorage("USER_DETAILS")?.role || null;

export const checkIsSuperAdmin = () => getUserRole() === ROLES.PLATFORM_ADMIN;

export const checkIsStateAdmin = () => getUserRole() === ROLES.STATE_DOT_ADMIN;

export const checkIsAdmin = () => getUserRole() === ROLES.COMPANY_ADMIN;

export const checkIsEmployee = () => getUserRole() === ROLES.COMPANY_EMPLOYEE;

export const crrObjClone = (objToAssignValues, ObjToInheritValuesFrom) => {
  for (const key of Object.keys(ObjToInheritValuesFrom)) {
    objToAssignValues[key] = ObjToInheritValuesFrom[key];
  }

  return objToAssignValues;
};

export function scrollToElement(element) {
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  }
}

export const handleContactUsClick = (e, customSubject, customBody) => {
  e.preventDefault();
  const encEmail = "c3VwcG9ydEBjeWJyYmFzZS5jb20=";
  const email = atob(encEmail);
  const subject = customSubject || "CYBRBASE Account";
  const body =
    customBody ||
    "I would like to learn how I can sign up for CYBRBASE to simplify my cybersecurity assessments and reduce risk for my agency.";
  const mailtoLink = `mailto:${email}?body=${encodeURIComponent(
    body
  )}&subject=${encodeURIComponent(subject)}`;
  window.open(mailtoLink, "_blank", "noopener,noreferrer");
};

export const downloadBlob = (data, filename, type = "text/csv") => {
  const blob = new Blob([data], { type });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);
  a.click();

  // Cleanup
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

//Survey - util

export const getAnswerColor = (colorId) => {
  switch (colorId) {
    case ANSWERS.Yes:
    case "Yes":
      return RESPONSE_COLORS.Yes; // Green

    case ANSWERS.Incomplete:
    case "Incomplete":
      return RESPONSE_COLORS.Incomplete; // Yellow

    case ANSWERS.No:
    case "No":
      return RESPONSE_COLORS.No; // Red

    default:
      return RESPONSE_COLORS["Not Answered"]; // Default Grey
  }
};

export const getAnswerText = (colorId) => {
  switch (colorId) {
    case ANSWERS.Yes:
      return "Yes";
    case ANSWERS.Incomplete:
      return "Incomplete";
    case ANSWERS.No:
      return "No";
    default:
      return `${colorId || "Not answered"}`;
  }
};
